export const GET_TERM = 'GET_TERM';

